import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#EEE1E8] to-[#DCCFD7]">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-lg text-center">
        <div className="mb-6">
          <h1 className="text-9xl font-bold text-[#AD0C62] mb-4">404</h1>
          <h2 className="text-3xl font-bold text-[#621C43] mb-2">Page Not Found</h2>
          <p className="text-gray-600 text-lg">
            The page you are looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="flex gap-4">
          <button
            onClick={() => navigate(-1)}
            className="flex-1 py-3 px-4 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition font-medium"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/dashboard')}
            className="flex-1 py-3 px-4 bg-[#EA600E] text-white rounded-md hover:bg-orange-600 transition font-medium"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
